import { createGlobalStyle } from 'styled-components';
import { COLORS } from '@/theme';

const FontStyles = createGlobalStyle`
  @font-face {
    font-family: 'e-Ukraine';
    src: url('/fonts/e-Ukraine-Thin.otf') format('opentype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'e-Ukraine';
    src: url('/fonts/e-Ukraine-Regular.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'e-Ukraine';
    src: url('/fonts/e-Ukraine-Medium.otf') format('opentype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'e-Ukraine';
    src: url('/fonts/e-Ukraine-Bold.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
  }
`;

const GlobalStyles = createGlobalStyle`
  body {
    color: ${COLORS.DARKEST_GRAY};
  }

  body * {
    font-family: 'e-Ukraine', sans-serif;
  }

  a {
    text-decoration: none;
  }
  
  .ant-input, .ant-select {
    font-family: 'e-Ukraine', sans-serif;
    font-size: 0.75rem;
  }
  
  .ant-input-affix-wrapper, .ant-picker, .ant-select .ant-select-selector {
    min-height: 40px;
  }
`;

const GlobalStyleComponent = () => (
  <>
    <FontStyles />
    <GlobalStyles />
  </>
);

export default GlobalStyleComponent;
